export const SHOW_MODAL = "UI:SHOW_MODAL";
export const HIDE_MODAL = "UI:HIDE_MODAL";

// GIFTS & BEQUESTS PAGES
export const BQ_PAGE_CHANGE = "UI:BQ_PAGE_CHANGE";
export const STORE_PREV_BQ_PAGE = "UI:STORE_PREV_BQ_PAGE";
